export const PLAN_PRICE_IDS = {
  free: [],
  civilian_plus: ['price_1SViAmD8lHq4co6YRAbNIvVx', 'price_1SViAnD8lHq4co6Yg5MQ1Hyx'],
  civilian_pro: ['price_1SViAoD8lHq4co6YWdZ0sbh0', 'price_1SViAoD8lHq4co6Y3MlnNnNz'],
  lawyer_pro: ['price_1SViApD8lHq4co6YclJLSTzz', 'price_1SViApD8lHq4co6YXfkhlTyG'],
  firm: ['price_1SViAqD8lHq4co6YoV710Iyk', 'price_1SViAqD8lHq4co6YDcUgqSGj'],
  insurance_partnership: ['price_1STvAkD8lHq4co6Y6wpCcArj'],
};

export type PlanId = keyof typeof PLAN_PRICE_IDS;